const MOJIBAKE_MARKERS = /[ÃÂâ]/;
const REPLACEMENT_CHAR = '�';
const MAX_PASSES = 2;

const markerCount = (value: string) => (value.match(/[ÃÂâ]/g) ?? []).length;

// Text som skickats som UTF-8 men lästs som latin-1 kommer fram som "HÃ¤r" i
// stället för "Här". Vi tolkar tecknen som bytes igen och avkodar om.
//
// Två gränser är medvetna. Tecken över U+00FF överlever inte `& 0xff`, så
// cp1252-trasig text (tankstreck, typografiska citattecken, €) går inte att
// laga — den lämnas orörd i stället för att bli halvt sönder. Och resultatet
// behålls bara om det blev FÄRRE markörer, annars har vi gissat fel.
export const maybeFixMojibake = (text: string): string => {
  if (!text) return text;

  let current = text;

  for (let pass = 0; pass < MAX_PASSES; pass += 1) {
    if (!MOJIBAKE_MARKERS.test(current)) break;

    try {
      const bytes = Uint8Array.from(current, (char) => char.charCodeAt(0) & 0xff);
      const decoded = new TextDecoder('utf-8').decode(bytes);

      // Ersättningstecknet betyder att bytesen inte var giltig UTF-8 — då var
      // texten inte trasig på det sätt vi trodde, och vi rör den inte.
      if (!decoded || decoded.includes(REPLACEMENT_CHAR)) break;
      if (markerCount(decoded) >= markerCount(current)) break;

      current = decoded;
    } catch {
      break;
    }
  }

  return current;
};
